//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PROVIDERDIRECTORY_API_BASE_URL = new InjectionToken<string>('PROVIDERDIRECTORY_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class ProviderDirectoryFunctionService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(PROVIDERDIRECTORY_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    anonymous(): Observable<string> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnonymous(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnonymous(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processAnonymous(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAttendant(body?: AttendantRequest | undefined): Observable<AttendantResponseModel> {
        let url_ = this.baseUrl + "/api/Attendant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAttendant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAttendant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendantResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendantResponseModel>;
        }));
    }

    protected processCreateAttendant(response: HttpResponseBase): Observable<AttendantResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendantResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAttendant(body?: AttendantRequest | undefined): Observable<AttendantResponseModel> {
        let url_ = this.baseUrl + "/api/Attendant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAttendant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAttendant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendantResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendantResponseModel>;
        }));
    }

    protected processUpdateAttendant(response: HttpResponseBase): Observable<AttendantResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendantResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationToCheck_Lat (optional) 
     * @param locationToCheck_Long (optional) 
     * @param radius (optional) 
     * @param zipCode (optional) 
     * @param hours (optional) 
     * @param day (optional) 
     * @param distanceType (optional) 
     * @return Success
     */
    getAttendantsWithinRadius(locationToCheck_Lat?: number | undefined, locationToCheck_Long?: number | undefined, radius?: number | undefined, zipCode?: number | undefined, hours?: number | undefined, day?: string | undefined, distanceType?: DistanceType | undefined): Observable<WithinRadiusAttendantResponseIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/api/Attendant?";
        if (locationToCheck_Lat === null)
            throw new globalThis.Error("The parameter 'locationToCheck_Lat' cannot be null.");
        else if (locationToCheck_Lat !== undefined)
            url_ += "LocationToCheck.Lat=" + encodeURIComponent("" + locationToCheck_Lat) + "&";
        if (locationToCheck_Long === null)
            throw new globalThis.Error("The parameter 'locationToCheck_Long' cannot be null.");
        else if (locationToCheck_Long !== undefined)
            url_ += "LocationToCheck.Long=" + encodeURIComponent("" + locationToCheck_Long) + "&";
        if (radius === null)
            throw new globalThis.Error("The parameter 'radius' cannot be null.");
        else if (radius !== undefined)
            url_ += "Radius=" + encodeURIComponent("" + radius) + "&";
        if (zipCode === null)
            throw new globalThis.Error("The parameter 'zipCode' cannot be null.");
        else if (zipCode !== undefined)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (hours === null)
            throw new globalThis.Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
        if (day === null)
            throw new globalThis.Error("The parameter 'day' cannot be null.");
        else if (day !== undefined)
            url_ += "Day=" + encodeURIComponent("" + day) + "&";
        if (distanceType === null)
            throw new globalThis.Error("The parameter 'distanceType' cannot be null.");
        else if (distanceType !== undefined)
            url_ += "DistanceType=" + encodeURIComponent("" + distanceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendantsWithinRadius(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendantsWithinRadius(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WithinRadiusAttendantResponseIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WithinRadiusAttendantResponseIEnumerableResponseModel>;
        }));
    }

    protected processGetAttendantsWithinRadius(response: HttpResponseBase): Observable<WithinRadiusAttendantResponseIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WithinRadiusAttendantResponseIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAttendantById(id: string): Observable<AttendantResponseModel> {
        let url_ = this.baseUrl + "/api/Attendant/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttendantById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttendantById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendantResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendantResponseModel>;
        }));
    }

    protected processGetAttendantById(response: HttpResponseBase): Observable<AttendantResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendantResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    affirm(userId: string): Observable<AttendantIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/api/Attendant/Affirm/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAffirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAffirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendantIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendantIEnumerableResponseModel>;
        }));
    }

    protected processAffirm(response: HttpResponseBase): Observable<AttendantIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendantIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPublicAttendantProfileById(id: string): Observable<BaseAttendantResponseModel> {
        let url_ = this.baseUrl + "/api/Attendant/public/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublicAttendantProfileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublicAttendantProfileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseAttendantResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseAttendantResponseModel>;
        }));
    }

    protected processGetPublicAttendantProfileById(response: HttpResponseBase): Observable<BaseAttendantResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaseAttendantResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param requestType (optional) 
     * @param userId (optional) 
     * @param item (optional) 
     * @return Success
     */
    upload(requestType?: RequestType | undefined, userId?: string | undefined, item?: FileParameter | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Blob?";
        if (requestType === null)
            throw new globalThis.Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (item === null || item === undefined)
            throw new globalThis.Error("The parameter 'item' cannot be null.");
        else
            content_.append("item", item.data, item.fileName ? item.fileName : "item");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param item (optional) 
     * @return Success
     */
    updateBlob(userId?: string | undefined, item?: FileParameter | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Blob?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (item === null || item === undefined)
            throw new globalThis.Error("The parameter 'item' cannot be null.");
        else
            content_.append("item", item.data, item.fileName ? item.fileName : "item");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBlob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBlob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateBlob(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllReviewRequest(): Observable<ReviewRequestIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/api/ReviewRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReviewRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReviewRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewRequestIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewRequestIEnumerableResponseModel>;
        }));
    }

    protected processGetAllReviewRequest(response: HttpResponseBase): Observable<ReviewRequestIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReviewRequestIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createReviewRequest(body?: ReviewRequest[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ReviewRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReviewRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReviewRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateReviewRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateReviewRequest(body?: ReviewRequest[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ReviewRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateReviewRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getReviewRequestByUserId(userId: string): Observable<ReviewRequestIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/api/ReviewRequest/{userId}";
        if (userId === undefined || userId === null)
            throw new globalThis.Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewRequestByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewRequestByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReviewRequestIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReviewRequestIEnumerableResponseModel>;
        }));
    }

    protected processGetReviewRequestByUserId(response: HttpResponseBase): Observable<ReviewRequestIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReviewRequestIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createZipCode(body?: CreateZipCodeRequest | undefined): Observable<OkObjectResult> {
        let url_ = this.baseUrl + "/api/ZipCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZipCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZipCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OkObjectResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OkObjectResult>;
        }));
    }

    protected processCreateZipCode(response: HttpResponseBase): Observable<OkObjectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OkObjectResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    validateZipCode(zipCode: number): Observable<BooleanResponseModel> {
        let url_ = this.baseUrl + "/api/ZipCode/validate/{zipCode}";
        if (zipCode === undefined || zipCode === null)
            throw new globalThis.Error("The parameter 'zipCode' must be defined.");
        url_ = url_.replace("{zipCode}", encodeURIComponent("" + zipCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateZipCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateZipCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseModel>;
        }));
    }

    protected processValidateZipCode(response: HttpResponseBase): Observable<BooleanResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyAttendant(body?: EmailRequest | undefined): Observable<BooleanResponseModel> {
        let url_ = this.baseUrl + "/Attendant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyAttendant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyAttendant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseModel>;
        }));
    }

    protected processNotifyAttendant(response: HttpResponseBase): Observable<BooleanResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    reaffirmNotification(body?: IdEmailRequest[] | undefined): Observable<BooleanResponseModel> {
        let url_ = this.baseUrl + "/Attendant/Reaffirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReaffirmNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReaffirmNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BooleanResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BooleanResponseModel>;
        }));
    }

    protected processReaffirmNotification(response: HttpResponseBase): Observable<BooleanResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BooleanResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllCertifications(): Observable<CertificationIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/Certification";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCertifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCertifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationIEnumerableResponseModel>;
        }));
    }

    protected processGetAllCertifications(response: HttpResponseBase): Observable<CertificationIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificationIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllLanguages(): Observable<LanguageIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/Language";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LanguageIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LanguageIEnumerableResponseModel>;
        }));
    }

    protected processGetAllLanguages(response: HttpResponseBase): Observable<LanguageIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param email (optional) 
     * @param firstName (optional) 
     * @param lastName (optional) 
     * @param state (optional) 
     * @param zipcode (optional) 
     * @param status (optional) 
     * @param certification_Id (optional) 
     * @param certification_Name (optional) 
     * @param certification_CreatedOn (optional) 
     * @param certification_UpdatedOn (optional) 
     * @param certification_CreatedBy (optional) 
     * @param certification_UpdatedBy (optional) 
     * @param certification_IsDeleted (optional) 
     * @return Success
     */
    getBySearchCriteria(userId?: string | undefined, email?: string | undefined, firstName?: string | undefined, lastName?: string | undefined, state?: States | undefined, zipcode?: number | undefined, status?: ProfileStatus | undefined, certification_Id?: number | undefined, certification_Name?: string | undefined, certification_CreatedOn?: Date | undefined, certification_UpdatedOn?: Date | undefined, certification_CreatedBy?: string | undefined, certification_UpdatedBy?: string | undefined, certification_IsDeleted?: boolean | undefined): Observable<AttendantIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/Search?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (firstName === null)
            throw new globalThis.Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new globalThis.Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (state === null)
            throw new globalThis.Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (zipcode === null)
            throw new globalThis.Error("The parameter 'zipcode' cannot be null.");
        else if (zipcode !== undefined)
            url_ += "Zipcode=" + encodeURIComponent("" + zipcode) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (certification_Id === null)
            throw new globalThis.Error("The parameter 'certification_Id' cannot be null.");
        else if (certification_Id !== undefined)
            url_ += "Certification.Id=" + encodeURIComponent("" + certification_Id) + "&";
        if (certification_Name === null)
            throw new globalThis.Error("The parameter 'certification_Name' cannot be null.");
        else if (certification_Name !== undefined)
            url_ += "Certification.Name=" + encodeURIComponent("" + certification_Name) + "&";
        if (certification_CreatedOn === null)
            throw new globalThis.Error("The parameter 'certification_CreatedOn' cannot be null.");
        else if (certification_CreatedOn !== undefined)
            url_ += "Certification.CreatedOn=" + encodeURIComponent(certification_CreatedOn ? "" + certification_CreatedOn.toISOString() : "") + "&";
        if (certification_UpdatedOn === null)
            throw new globalThis.Error("The parameter 'certification_UpdatedOn' cannot be null.");
        else if (certification_UpdatedOn !== undefined)
            url_ += "Certification.UpdatedOn=" + encodeURIComponent(certification_UpdatedOn ? "" + certification_UpdatedOn.toISOString() : "") + "&";
        if (certification_CreatedBy === null)
            throw new globalThis.Error("The parameter 'certification_CreatedBy' cannot be null.");
        else if (certification_CreatedBy !== undefined)
            url_ += "Certification.CreatedBy=" + encodeURIComponent("" + certification_CreatedBy) + "&";
        if (certification_UpdatedBy === null)
            throw new globalThis.Error("The parameter 'certification_UpdatedBy' cannot be null.");
        else if (certification_UpdatedBy !== undefined)
            url_ += "Certification.UpdatedBy=" + encodeURIComponent("" + certification_UpdatedBy) + "&";
        if (certification_IsDeleted === null)
            throw new globalThis.Error("The parameter 'certification_IsDeleted' cannot be null.");
        else if (certification_IsDeleted !== undefined)
            url_ += "Certification.IsDeleted=" + encodeURIComponent("" + certification_IsDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySearchCriteria(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySearchCriteria(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendantIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendantIEnumerableResponseModel>;
        }));
    }

    protected processGetBySearchCriteria(response: HttpResponseBase): Observable<AttendantIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendantIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllServices(): Observable<ServiceIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/Service";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceIEnumerableResponseModel>;
        }));
    }

    protected processGetAllServices(response: HttpResponseBase): Observable<ServiceIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllWorkPreferences(): Observable<WorkPreferenceIEnumerableResponseModel> {
        let url_ = this.baseUrl + "/WorkPreference";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWorkPreferences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWorkPreferences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkPreferenceIEnumerableResponseModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkPreferenceIEnumerableResponseModel>;
        }));
    }

    protected processGetAllWorkPreferences(response: HttpResponseBase): Observable<WorkPreferenceIEnumerableResponseModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkPreferenceIEnumerableResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class Assembly implements IAssembly {
    readonly definedTypes?: TypeInfo[] | undefined;
    readonly exportedTypes?: Type[] | undefined;
    readonly codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    readonly fullName?: string | undefined;
    readonly imageRuntimeVersion?: string | undefined;
    readonly isDynamic?: boolean;
    readonly location?: string | undefined;
    readonly reflectionOnly?: boolean;
    readonly isCollectible?: boolean;
    readonly isFullyTrusted?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    readonly modules?: Module[] | undefined;
    readonly globalAssemblyCache?: boolean;
    readonly hostContext?: number;
    securityRuleSet?: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (this as any).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (this as any).definedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (this as any).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (this as any).exportedTypes!.push(Type.fromJS(item));
            }
            (this as any).codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : undefined as any;
            (this as any).fullName = _data["fullName"];
            (this as any).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (this as any).isDynamic = _data["isDynamic"];
            (this as any).location = _data["location"];
            (this as any).reflectionOnly = _data["reflectionOnly"];
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : undefined as any;
            if (Array.isArray(_data["modules"])) {
                (this as any).modules = [] as any;
                for (let item of _data["modules"])
                    (this as any).modules!.push(Module.fromJS(item));
            }
            (this as any).globalAssemblyCache = _data["globalAssemblyCache"];
            (this as any).hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : undefined as any;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : undefined as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes?: TypeInfo[] | undefined;
    exportedTypes?: Type[] | undefined;
    codeBase?: string | undefined;
    entryPoint?: MethodInfo;
    fullName?: string | undefined;
    imageRuntimeVersion?: string | undefined;
    isDynamic?: boolean;
    location?: string | undefined;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    escapedCodeBase?: string | undefined;
    manifestModule?: Module;
    modules?: Module[] | undefined;
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;
}

export class Attendant implements IAttendant {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    prefHireDate?: Date;
    about?: string | undefined;
    snippet?: string | undefined;
    travelDistance?: number;
    zip?: number;
    weeklyHours?: number;
    experience?: number;
    latitude?: number;
    longitude?: number;
    photoUrl?: string | undefined;
    resumeUrl?: string | undefined;
    state?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    isCO?: boolean;
    contractDate?: Date;
    approvalDate?: Date;
    createdOn?: Date;
    certifications?: Certification[] | undefined;
    services?: Service[] | undefined;
    schedules?: Schedule[] | undefined;
    workPreferences?: WorkPreference[] | undefined;
    languages?: Language[] | undefined;
    email?: string | undefined;

    constructor(data?: IAttendant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : undefined as any;
            this.prefHireDate = _data["prefHireDate"] ? new Date(_data["prefHireDate"].toString()) : undefined as any;
            this.about = _data["about"];
            this.snippet = _data["snippet"];
            this.travelDistance = _data["travelDistance"];
            this.zip = _data["zip"];
            this.weeklyHours = _data["weeklyHours"];
            this.experience = _data["experience"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.photoUrl = _data["photoUrl"];
            this.resumeUrl = _data["resumeUrl"];
            this.state = _data["state"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isCO = _data["isCO"];
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : undefined as any;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(Certification.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Service.fromJS(item));
            }
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(Schedule.fromJS(item));
            }
            if (Array.isArray(_data["workPreferences"])) {
                this.workPreferences = [] as any;
                for (let item of _data["workPreferences"])
                    this.workPreferences!.push(WorkPreference.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): Attendant {
        data = typeof data === 'object' ? data : {};
        let result = new Attendant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined as any;
        data["prefHireDate"] = this.prefHireDate ? this.prefHireDate.toISOString() : undefined as any;
        data["about"] = this.about;
        data["snippet"] = this.snippet;
        data["travelDistance"] = this.travelDistance;
        data["zip"] = this.zip;
        data["weeklyHours"] = this.weeklyHours;
        data["experience"] = this.experience;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["photoUrl"] = this.photoUrl;
        data["resumeUrl"] = this.resumeUrl;
        data["state"] = this.state;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isCO"] = this.isCO;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : undefined as any;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workPreferences)) {
            data["workPreferences"] = [];
            for (let item of this.workPreferences)
                data["workPreferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["email"] = this.email;
        return data;
    }
}

export interface IAttendant {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    prefHireDate?: Date;
    about?: string | undefined;
    snippet?: string | undefined;
    travelDistance?: number;
    zip?: number;
    weeklyHours?: number;
    experience?: number;
    latitude?: number;
    longitude?: number;
    photoUrl?: string | undefined;
    resumeUrl?: string | undefined;
    state?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    isCO?: boolean;
    contractDate?: Date;
    approvalDate?: Date;
    createdOn?: Date;
    certifications?: Certification[] | undefined;
    services?: Service[] | undefined;
    schedules?: Schedule[] | undefined;
    workPreferences?: WorkPreference[] | undefined;
    languages?: Language[] | undefined;
    email?: string | undefined;
}

export class AttendantIEnumerableResponseModel implements IAttendantIEnumerableResponseModel {
    data?: Attendant[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IAttendantIEnumerableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Attendant.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AttendantIEnumerableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttendantIEnumerableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IAttendantIEnumerableResponseModel {
    data?: Attendant[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class AttendantRequest implements IAttendantRequest {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    about?: string | undefined;
    snippet?: string | undefined;
    travelDistance?: number;
    zip?: number;
    experience?: number;
    weeklyHours?: number;
    prefHireDate?: Date;
    latitude?: number;
    longitude?: number;
    isCO?: boolean;
    isActive?: boolean;
    status?: string | undefined;
    state?: string | undefined;
    certifications?: Certification[] | undefined;
    services?: Service[] | undefined;
    schedules?: Schedule[] | undefined;
    workPreferences?: WorkPreference[] | undefined;
    languages?: Language[] | undefined;
    fullUpdate?: boolean;
    emailUpdate?: boolean;
    approvalDate?: Date | undefined;

    constructor(data?: IAttendantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : undefined as any;
            this.about = _data["about"];
            this.snippet = _data["snippet"];
            this.travelDistance = _data["travelDistance"];
            this.zip = _data["zip"];
            this.experience = _data["experience"];
            this.weeklyHours = _data["weeklyHours"];
            this.prefHireDate = _data["prefHireDate"] ? new Date(_data["prefHireDate"].toString()) : undefined as any;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.isCO = _data["isCO"];
            this.isActive = _data["isActive"];
            this.status = _data["status"];
            this.state = _data["state"];
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(Certification.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Service.fromJS(item));
            }
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(Schedule.fromJS(item));
            }
            if (Array.isArray(_data["workPreferences"])) {
                this.workPreferences = [] as any;
                for (let item of _data["workPreferences"])
                    this.workPreferences!.push(WorkPreference.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
            this.fullUpdate = _data["fullUpdate"];
            this.emailUpdate = _data["emailUpdate"];
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AttendantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AttendantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined as any;
        data["about"] = this.about;
        data["snippet"] = this.snippet;
        data["travelDistance"] = this.travelDistance;
        data["zip"] = this.zip;
        data["experience"] = this.experience;
        data["weeklyHours"] = this.weeklyHours;
        data["prefHireDate"] = this.prefHireDate ? this.prefHireDate.toISOString() : undefined as any;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["isCO"] = this.isCO;
        data["isActive"] = this.isActive;
        data["status"] = this.status;
        data["state"] = this.state;
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workPreferences)) {
            data["workPreferences"] = [];
            for (let item of this.workPreferences)
                data["workPreferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        data["fullUpdate"] = this.fullUpdate;
        data["emailUpdate"] = this.emailUpdate;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IAttendantRequest {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    userId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    about?: string | undefined;
    snippet?: string | undefined;
    travelDistance?: number;
    zip?: number;
    experience?: number;
    weeklyHours?: number;
    prefHireDate?: Date;
    latitude?: number;
    longitude?: number;
    isCO?: boolean;
    isActive?: boolean;
    status?: string | undefined;
    state?: string | undefined;
    certifications?: Certification[] | undefined;
    services?: Service[] | undefined;
    schedules?: Schedule[] | undefined;
    workPreferences?: WorkPreference[] | undefined;
    languages?: Language[] | undefined;
    fullUpdate?: boolean;
    emailUpdate?: boolean;
    approvalDate?: Date | undefined;
}

export class AttendantResponseModel implements IAttendantResponseModel {
    data?: Attendant;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IAttendantResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? Attendant.fromJS(_data["data"]) : undefined as any;
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AttendantResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new AttendantResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IAttendantResponseModel {
    data?: Attendant;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class BaseAttendant implements IBaseAttendant {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    prefHireDate?: Date;
    about?: string | undefined;
    snippet?: string | undefined;
    travelDistance?: number;
    zip?: number;
    weeklyHours?: number;
    experience?: number;
    latitude?: number;
    longitude?: number;
    photoUrl?: string | undefined;
    resumeUrl?: string | undefined;
    state?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    isCO?: boolean;
    contractDate?: Date;
    approvalDate?: Date;
    createdOn?: Date;
    certifications?: Certification[] | undefined;
    services?: Service[] | undefined;
    schedules?: Schedule[] | undefined;
    workPreferences?: WorkPreference[] | undefined;
    languages?: Language[] | undefined;

    constructor(data?: IBaseAttendant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.dob = _data["dob"] ? new Date(_data["dob"].toString()) : undefined as any;
            this.prefHireDate = _data["prefHireDate"] ? new Date(_data["prefHireDate"].toString()) : undefined as any;
            this.about = _data["about"];
            this.snippet = _data["snippet"];
            this.travelDistance = _data["travelDistance"];
            this.zip = _data["zip"];
            this.weeklyHours = _data["weeklyHours"];
            this.experience = _data["experience"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.photoUrl = _data["photoUrl"];
            this.resumeUrl = _data["resumeUrl"];
            this.state = _data["state"];
            this.status = _data["status"];
            this.isActive = _data["isActive"];
            this.isCO = _data["isCO"];
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : undefined as any;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : undefined as any;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            if (Array.isArray(_data["certifications"])) {
                this.certifications = [] as any;
                for (let item of _data["certifications"])
                    this.certifications!.push(Certification.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(Service.fromJS(item));
            }
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(Schedule.fromJS(item));
            }
            if (Array.isArray(_data["workPreferences"])) {
                this.workPreferences = [] as any;
                for (let item of _data["workPreferences"])
                    this.workPreferences!.push(WorkPreference.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(Language.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseAttendant {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAttendant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["dob"] = this.dob ? this.dob.toISOString() : undefined as any;
        data["prefHireDate"] = this.prefHireDate ? this.prefHireDate.toISOString() : undefined as any;
        data["about"] = this.about;
        data["snippet"] = this.snippet;
        data["travelDistance"] = this.travelDistance;
        data["zip"] = this.zip;
        data["weeklyHours"] = this.weeklyHours;
        data["experience"] = this.experience;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["photoUrl"] = this.photoUrl;
        data["resumeUrl"] = this.resumeUrl;
        data["state"] = this.state;
        data["status"] = this.status;
        data["isActive"] = this.isActive;
        data["isCO"] = this.isCO;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : undefined as any;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : undefined as any;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        if (Array.isArray(this.certifications)) {
            data["certifications"] = [];
            for (let item of this.certifications)
                data["certifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.workPreferences)) {
            data["workPreferences"] = [];
            for (let item of this.workPreferences)
                data["workPreferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBaseAttendant {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    dob?: Date;
    prefHireDate?: Date;
    about?: string | undefined;
    snippet?: string | undefined;
    travelDistance?: number;
    zip?: number;
    weeklyHours?: number;
    experience?: number;
    latitude?: number;
    longitude?: number;
    photoUrl?: string | undefined;
    resumeUrl?: string | undefined;
    state?: string | undefined;
    status?: string | undefined;
    isActive?: boolean;
    isCO?: boolean;
    contractDate?: Date;
    approvalDate?: Date;
    createdOn?: Date;
    certifications?: Certification[] | undefined;
    services?: Service[] | undefined;
    schedules?: Schedule[] | undefined;
    workPreferences?: WorkPreference[] | undefined;
    languages?: Language[] | undefined;
}

export class BaseAttendantResponseModel implements IBaseAttendantResponseModel {
    data?: BaseAttendant;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IBaseAttendantResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? BaseAttendant.fromJS(_data["data"]) : undefined as any;
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BaseAttendantResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseAttendantResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined as any;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IBaseAttendantResponseModel {
    data?: BaseAttendant;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class BooleanResponseModel implements IBooleanResponseModel {
    data?: boolean;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IBooleanResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): BooleanResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IBooleanResponseModel {
    data?: boolean;
    isSuccess?: boolean;
    message?: string | undefined;
}

export enum CallingConventions {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _32 = 32,
    _64 = 64,
}

export class Certification implements ICertification {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;

    constructor(data?: ICertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Certification {
        data = typeof data === 'object' ? data : {};
        let result = new Certification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ICertification {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;
}

export class CertificationIEnumerableResponseModel implements ICertificationIEnumerableResponseModel {
    data?: Certification[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: ICertificationIEnumerableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Certification.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CertificationIEnumerableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationIEnumerableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface ICertificationIEnumerableResponseModel {
    data?: Certification[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (this as any).isAbstract = _data["isAbstract"];
            (this as any).isConstructor = _data["isConstructor"];
            (this as any).isFinal = _data["isFinal"];
            (this as any).isHideBySig = _data["isHideBySig"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isStatic = _data["isStatic"];
            (this as any).isVirtual = _data["isVirtual"];
            (this as any).isAssembly = _data["isAssembly"];
            (this as any).isFamily = _data["isFamily"];
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (this as any).isPrivate = _data["isPrivate"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (this as any).isGenericMethod = _data["isGenericMethod"];
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (this as any).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined as any;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        return data;
    }
}

export interface IConstructorInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
}

export class CreateZipCodeRequest implements ICreateZipCodeRequest {
    zipCode?: number;
    latitude?: number;
    longitude?: number;

    constructor(data?: ICreateZipCodeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zipCode = _data["zipCode"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CreateZipCodeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateZipCodeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zipCode"] = this.zipCode;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ICreateZipCodeRequest {
    zipCode?: number;
    latitude?: number;
    longitude?: number;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    readonly constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments?: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"] ? Type.fromJS(_data["attributeType"]) : undefined as any;
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : undefined as any;
            if (Array.isArray(_data["constructorArguments"])) {
                (this as any).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (this as any).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (this as any).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (this as any).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType ? this.attributeType.toJSON() : undefined as any;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : undefined as any;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType?: Type;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[] | undefined;
    namedArguments?: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    readonly memberName?: string | undefined;
    readonly isField?: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : undefined as any;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : undefined as any;
            (this as any).memberName = _data["memberName"];
            (this as any).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : undefined as any;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : undefined as any;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string | undefined;
    isField?: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"] ? Type.fromJS(_data["argumentType"]) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType ? this.argumentType.toJSON() : undefined as any;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: Type;
    value?: any | undefined;
}

export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export enum DistanceType {
    _0 = 0,
    _1 = 1,
}

export class EmailRequest implements IEmailRequest {
    template?: string | undefined;
    emailTos?: string[] | undefined;
    emailCC?: string[] | undefined;
    placeHolderInfo?: { [key: string]: string; } | undefined;
    emailSubject?: string | undefined;
    replyTo?: string | undefined;

    constructor(data?: IEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.template = _data["template"];
            if (Array.isArray(_data["emailTos"])) {
                this.emailTos = [] as any;
                for (let item of _data["emailTos"])
                    this.emailTos!.push(item);
            }
            if (Array.isArray(_data["emailCC"])) {
                this.emailCC = [] as any;
                for (let item of _data["emailCC"])
                    this.emailCC!.push(item);
            }
            if (_data["placeHolderInfo"]) {
                this.placeHolderInfo = {} as any;
                for (let key in _data["placeHolderInfo"]) {
                    if (_data["placeHolderInfo"].hasOwnProperty(key))
                        (this.placeHolderInfo as any)![key] = _data["placeHolderInfo"][key];
                }
            }
            this.emailSubject = _data["emailSubject"];
            this.replyTo = _data["replyTo"];
        }
    }

    static fromJS(data: any): EmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["template"] = this.template;
        if (Array.isArray(this.emailTos)) {
            data["emailTos"] = [];
            for (let item of this.emailTos)
                data["emailTos"].push(item);
        }
        if (Array.isArray(this.emailCC)) {
            data["emailCC"] = [];
            for (let item of this.emailCC)
                data["emailCC"].push(item);
        }
        if (this.placeHolderInfo) {
            data["placeHolderInfo"] = {};
            for (let key in this.placeHolderInfo) {
                if (this.placeHolderInfo.hasOwnProperty(key))
                    (data["placeHolderInfo"] as any)[key] = (this.placeHolderInfo as any)[key];
            }
        }
        data["emailSubject"] = this.emailSubject;
        data["replyTo"] = this.replyTo;
        return data;
    }
}

export interface IEmailRequest {
    template?: string | undefined;
    emailTos?: string[] | undefined;
    emailCC?: string[] | undefined;
    placeHolderInfo?: { [key: string]: string; } | undefined;
    emailSubject?: string | undefined;
    replyTo?: string | undefined;
}

export enum EventAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
}

export class EventInfo implements IEventInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    readonly isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    readonly isMulticast?: boolean;
    eventHandlerType?: Type;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            (this as any).isSpecialName = _data["isSpecialName"];
            this.addMethod = _data["addMethod"] ? MethodInfo.fromJS(_data["addMethod"]) : undefined as any;
            this.removeMethod = _data["removeMethod"] ? MethodInfo.fromJS(_data["removeMethod"]) : undefined as any;
            this.raiseMethod = _data["raiseMethod"] ? MethodInfo.fromJS(_data["raiseMethod"]) : undefined as any;
            (this as any).isMulticast = _data["isMulticast"];
            this.eventHandlerType = _data["eventHandlerType"] ? Type.fromJS(_data["eventHandlerType"]) : undefined as any;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["addMethod"] = this.addMethod ? this.addMethod.toJSON() : undefined as any;
        data["removeMethod"] = this.removeMethod ? this.removeMethod.toJSON() : undefined as any;
        data["raiseMethod"] = this.raiseMethod ? this.raiseMethod.toJSON() : undefined as any;
        data["isMulticast"] = this.isMulticast;
        data["eventHandlerType"] = this.eventHandlerType ? this.eventHandlerType.toJSON() : undefined as any;
        return data;
    }
}

export interface IEventInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: EventAttributes;
    isSpecialName?: boolean;
    addMethod?: MethodInfo;
    removeMethod?: MethodInfo;
    raiseMethod?: MethodInfo;
    isMulticast?: boolean;
    eventHandlerType?: Type;
}

export enum FieldAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _32768 = 32768,
    _38144 = 38144,
}

export class FieldInfo implements IFieldInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    readonly isInitOnly?: boolean;
    readonly isLiteral?: boolean;
    readonly isNotSerialized?: boolean;
    readonly isPinvokeImpl?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.attributes = _data["attributes"];
            this.fieldType = _data["fieldType"] ? Type.fromJS(_data["fieldType"]) : undefined as any;
            (this as any).isInitOnly = _data["isInitOnly"];
            (this as any).isLiteral = _data["isLiteral"];
            (this as any).isNotSerialized = _data["isNotSerialized"];
            (this as any).isPinvokeImpl = _data["isPinvokeImpl"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isStatic = _data["isStatic"];
            (this as any).isAssembly = _data["isAssembly"];
            (this as any).isFamily = _data["isFamily"];
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (this as any).isPrivate = _data["isPrivate"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
            this.fieldHandle = _data["fieldHandle"] ? RuntimeFieldHandle.fromJS(_data["fieldHandle"]) : undefined as any;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["fieldType"] = this.fieldType ? this.fieldType.toJSON() : undefined as any;
        data["isInitOnly"] = this.isInitOnly;
        data["isLiteral"] = this.isLiteral;
        data["isNotSerialized"] = this.isNotSerialized;
        data["isPinvokeImpl"] = this.isPinvokeImpl;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["fieldHandle"] = this.fieldHandle ? this.fieldHandle.toJSON() : undefined as any;
        return data;
    }
}

export interface IFieldInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    attributes?: FieldAttributes;
    fieldType?: Type;
    isInitOnly?: boolean;
    isLiteral?: boolean;
    isNotSerialized?: boolean;
    isPinvokeImpl?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    fieldHandle?: RuntimeFieldHandle;
}

export enum GenericParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _28 = 28,
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class IOutputFormatter implements IIOutputFormatter {

    constructor(data?: IIOutputFormatter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IOutputFormatter {
        data = typeof data === 'object' ? data : {};
        let result = new IOutputFormatter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIOutputFormatter {
}

export class IdEmailRequest implements IIdEmailRequest {
    userId?: string | undefined;
    email?: string | undefined;

    constructor(data?: IIdEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): IdEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IdEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        return data;
    }
}

export interface IIdEmailRequest {
    userId?: string | undefined;
    email?: string | undefined;
}

export class IntPtr implements IIntPtr {

    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIntPtr {
}

export class Language implements ILanguage {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;

    constructor(data?: ILanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Language {
        data = typeof data === 'object' ? data : {};
        let result = new Language();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILanguage {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;
}

export class LanguageIEnumerableResponseModel implements ILanguageIEnumerableResponseModel {
    data?: Language[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: ILanguageIEnumerableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Language.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LanguageIEnumerableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageIEnumerableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface ILanguageIEnumerableResponseModel {
    data?: Language[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export enum LayoutKind {
    _0 = 0,
    _2 = 2,
    _3 = 3,
}

export class MemberInfo implements IMemberInfo {
    memberType?: MemberTypes;
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (this as any).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType?: MemberTypes;
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
}

export enum MemberTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _191 = 191,
}

export enum MethodAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _53248 = 53248,
}

export class MethodBase implements IMethodBase {
    memberType?: MemberTypes;
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data["memberType"];
            (this as any).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (this as any).isAbstract = _data["isAbstract"];
            (this as any).isConstructor = _data["isConstructor"];
            (this as any).isFinal = _data["isFinal"];
            (this as any).isHideBySig = _data["isHideBySig"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isStatic = _data["isStatic"];
            (this as any).isVirtual = _data["isVirtual"];
            (this as any).isAssembly = _data["isAssembly"];
            (this as any).isFamily = _data["isFamily"];
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (this as any).isPrivate = _data["isPrivate"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (this as any).isGenericMethod = _data["isGenericMethod"];
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (this as any).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined as any;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        return data;
    }
}

export interface IMethodBase {
    memberType?: MemberTypes;
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
}

export enum MethodImplAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _4096 = 4096,
    _65535 = 65535,
}

export class MethodInfo implements IMethodInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    readonly isAbstract?: boolean;
    readonly isConstructor?: boolean;
    readonly isFinal?: boolean;
    readonly isHideBySig?: boolean;
    readonly isSpecialName?: boolean;
    readonly isStatic?: boolean;
    readonly isVirtual?: boolean;
    readonly isAssembly?: boolean;
    readonly isFamily?: boolean;
    readonly isFamilyAndAssembly?: boolean;
    readonly isFamilyOrAssembly?: boolean;
    readonly isPrivate?: boolean;
    readonly isPublic?: boolean;
    readonly isConstructedGenericMethod?: boolean;
    readonly isGenericMethod?: boolean;
    readonly isGenericMethodDefinition?: boolean;
    readonly containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            this.attributes = _data["attributes"];
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            (this as any).isAbstract = _data["isAbstract"];
            (this as any).isConstructor = _data["isConstructor"];
            (this as any).isFinal = _data["isFinal"];
            (this as any).isHideBySig = _data["isHideBySig"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isStatic = _data["isStatic"];
            (this as any).isVirtual = _data["isVirtual"];
            (this as any).isAssembly = _data["isAssembly"];
            (this as any).isFamily = _data["isFamily"];
            (this as any).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (this as any).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (this as any).isPrivate = _data["isPrivate"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (this as any).isGenericMethod = _data["isGenericMethod"];
            (this as any).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (this as any).containsGenericParameters = _data["containsGenericParameters"];
            this.methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : undefined as any;
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : undefined as any;
            this.returnType = _data["returnType"] ? Type.fromJS(_data["returnType"]) : undefined as any;
            this.returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : undefined as any;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : undefined as any;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : undefined as any;
        data["returnType"] = this.returnType ? this.returnType.toJSON() : undefined as any;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : undefined as any;
        return data;
    }
}

export interface IMethodInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    attributes?: MethodAttributes;
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    methodHandle?: RuntimeMethodHandle;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: Type;
    returnTypeCustomAttributes?: ICustomAttributeProvider;
}

export class Module implements IModule {
    assembly?: Assembly;
    readonly fullyQualifiedName?: string | undefined;
    readonly name?: string | undefined;
    readonly mdStreamVersion?: number;
    readonly moduleVersionId?: string;
    readonly scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined as any;
            (this as any).fullyQualifiedName = _data["fullyQualifiedName"];
            (this as any).name = _data["name"];
            (this as any).mdStreamVersion = _data["mdStreamVersion"];
            (this as any).moduleVersionId = _data["moduleVersionId"];
            (this as any).scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined as any;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly?: Assembly;
    fullyQualifiedName?: string | undefined;
    name?: string | undefined;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string | undefined;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion?: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion?: number;
}

export class OkObjectResult implements IOkObjectResult {
    value?: any | undefined;
    formatters?: IOutputFormatter[] | undefined;
    contentTypes?: string[] | undefined;
    declaredType?: Type;
    statusCode?: number | undefined;

    constructor(data?: IOkObjectResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            if (Array.isArray(_data["formatters"])) {
                this.formatters = [] as any;
                for (let item of _data["formatters"])
                    this.formatters!.push(IOutputFormatter.fromJS(item));
            }
            if (Array.isArray(_data["contentTypes"])) {
                this.contentTypes = [] as any;
                for (let item of _data["contentTypes"])
                    this.contentTypes!.push(item);
            }
            this.declaredType = _data["declaredType"] ? Type.fromJS(_data["declaredType"]) : undefined as any;
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): OkObjectResult {
        data = typeof data === 'object' ? data : {};
        let result = new OkObjectResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        if (Array.isArray(this.formatters)) {
            data["formatters"] = [];
            for (let item of this.formatters)
                data["formatters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contentTypes)) {
            data["contentTypes"] = [];
            for (let item of this.contentTypes)
                data["contentTypes"].push(item);
        }
        data["declaredType"] = this.declaredType ? this.declaredType.toJSON() : undefined as any;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IOkObjectResult {
    value?: any | undefined;
    formatters?: IOutputFormatter[] | undefined;
    contentTypes?: string[] | undefined;
    declaredType?: Type;
    statusCode?: number | undefined;
}

export enum ParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _61440 = 61440,
}

export class ParameterInfo implements IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    readonly name?: string | undefined;
    parameterType?: Type;
    readonly position?: number;
    readonly isIn?: boolean;
    readonly isLcid?: boolean;
    readonly isOptional?: boolean;
    readonly isOut?: boolean;
    readonly isRetval?: boolean;
    readonly defaultValue?: any | undefined;
    readonly rawDefaultValue?: any | undefined;
    readonly hasDefaultValue?: boolean;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly metadataToken?: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : undefined as any;
            (this as any).name = _data["name"];
            this.parameterType = _data["parameterType"] ? Type.fromJS(_data["parameterType"]) : undefined as any;
            (this as any).position = _data["position"];
            (this as any).isIn = _data["isIn"];
            (this as any).isLcid = _data["isLcid"];
            (this as any).isOptional = _data["isOptional"];
            (this as any).isOut = _data["isOut"];
            (this as any).isRetval = _data["isRetval"];
            (this as any).defaultValue = _data["defaultValue"];
            (this as any).rawDefaultValue = _data["rawDefaultValue"];
            (this as any).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : undefined as any;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType ? this.parameterType.toJSON() : undefined as any;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: Type;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[] | undefined;
    metadataToken?: number;
}

export enum ProfileStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export enum PropertyAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _62464 = 62464,
}

export class PropertyInfo implements IPropertyInfo {
    readonly name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    readonly isSpecialName?: boolean;
    readonly canRead?: boolean;
    readonly canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            this.memberType = _data["memberType"];
            this.propertyType = _data["propertyType"] ? Type.fromJS(_data["propertyType"]) : undefined as any;
            this.attributes = _data["attributes"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).canRead = _data["canRead"];
            (this as any).canWrite = _data["canWrite"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : undefined as any;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : undefined as any;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["memberType"] = this.memberType;
        data["propertyType"] = this.propertyType ? this.propertyType.toJSON() : undefined as any;
        data["attributes"] = this.attributes;
        data["isSpecialName"] = this.isSpecialName;
        data["canRead"] = this.canRead;
        data["canWrite"] = this.canWrite;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : undefined as any;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : undefined as any;
        return data;
    }
}

export interface IPropertyInfo {
    name?: string | undefined;
    declaringType?: Type;
    reflectedType?: Type;
    module?: Module;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    memberType?: MemberTypes;
    propertyType?: Type;
    attributes?: PropertyAttributes;
    isSpecialName?: boolean;
    canRead?: boolean;
    canWrite?: boolean;
    getMethod?: MethodInfo;
    setMethod?: MethodInfo;
}

export enum RequestType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ReviewRequest implements IReviewRequest {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    requestId?: number;
    revieweeId?: string | undefined;
    reviewerId?: string | undefined;
    reviewDate?: Date;
    status?: Status;
    type?: RequestType;
    metadata?: string | undefined;

    constructor(data?: IReviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.requestId = _data["requestId"];
            this.revieweeId = _data["revieweeId"];
            this.reviewerId = _data["reviewerId"];
            this.reviewDate = _data["reviewDate"] ? new Date(_data["reviewDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.type = _data["type"];
            this.metadata = _data["metadata"];
        }
    }

    static fromJS(data: any): ReviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["requestId"] = this.requestId;
        data["revieweeId"] = this.revieweeId;
        data["reviewerId"] = this.reviewerId;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["type"] = this.type;
        data["metadata"] = this.metadata;
        return data;
    }
}

export interface IReviewRequest {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    requestId?: number;
    revieweeId?: string | undefined;
    reviewerId?: string | undefined;
    reviewDate?: Date;
    status?: Status;
    type?: RequestType;
    metadata?: string | undefined;
}

export class ReviewRequestIEnumerableResponseModel implements IReviewRequestIEnumerableResponseModel {
    data?: ReviewRequest[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IReviewRequestIEnumerableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ReviewRequest.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReviewRequestIEnumerableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewRequestIEnumerableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IReviewRequestIEnumerableResponseModel {
    data?: ReviewRequest[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IRuntimeFieldHandle {
    value?: IntPtr;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value?: IntPtr;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value?: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? IntPtr.fromJS(_data["value"]) : undefined as any;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined as any;
        return data;
    }
}

export interface IRuntimeTypeHandle {
    value?: IntPtr;
}

export class Schedule implements ISchedule {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    dayOfWeek?: DayOfWeek;
    timeFrom?: TimeSpan;
    timeTo?: TimeSpan;

    constructor(data?: ISchedule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.timeFrom = _data["timeFrom"] ? TimeSpan.fromJS(_data["timeFrom"]) : undefined as any;
            this.timeTo = _data["timeTo"] ? TimeSpan.fromJS(_data["timeTo"]) : undefined as any;
        }
    }

    static fromJS(data: any): Schedule {
        data = typeof data === 'object' ? data : {};
        let result = new Schedule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["dayOfWeek"] = this.dayOfWeek;
        data["timeFrom"] = this.timeFrom ? this.timeFrom.toJSON() : undefined as any;
        data["timeTo"] = this.timeTo ? this.timeTo.toJSON() : undefined as any;
        return data;
    }
}

export interface ISchedule {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    dayOfWeek?: DayOfWeek;
    timeFrom?: TimeSpan;
    timeTo?: TimeSpan;
}

export enum SecurityRuleSet {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class Service implements IService {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;

    constructor(data?: IService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): Service {
        data = typeof data === 'object' ? data : {};
        let result = new Service();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IService {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;
}

export class ServiceIEnumerableResponseModel implements IServiceIEnumerableResponseModel {
    data?: Service[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IServiceIEnumerableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(Service.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ServiceIEnumerableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceIEnumerableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IServiceIEnumerableResponseModel {
    data?: Service[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export enum States {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,
    _11 = 11,
    _12 = 12,
    _13 = 13,
    _14 = 14,
    _15 = 15,
    _16 = 16,
    _17 = 17,
    _18 = 18,
    _19 = 19,
    _20 = 20,
    _21 = 21,
    _22 = 22,
    _23 = 23,
    _24 = 24,
    _25 = 25,
    _26 = 26,
    _27 = 27,
    _28 = 28,
    _29 = 29,
    _30 = 30,
    _31 = 31,
    _32 = 32,
    _33 = 33,
    _34 = 34,
    _35 = 35,
    _36 = 36,
    _37 = 37,
    _38 = 38,
    _39 = 39,
    _40 = 40,
    _41 = 41,
    _42 = 42,
    _43 = 43,
    _44 = 44,
    _45 = 45,
    _46 = 46,
    _47 = 47,
    _48 = 48,
    _49 = 49,
    _50 = 50,
}

export enum Status {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    readonly typeId?: any | undefined;
    value?: LayoutKind;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).typeId = _data["typeId"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeId"] = this.typeId;
        data["value"] = this.value;
        return data;
    }
}

export interface IStructLayoutAttribute {
    typeId?: any | undefined;
    value?: LayoutKind;
}

export class TimeSpan implements ITimeSpan {
    ticks?: number;
    readonly days?: number;
    readonly hours?: number;
    readonly milliseconds?: number;
    readonly microseconds?: number;
    readonly nanoseconds?: number;
    readonly minutes?: number;
    readonly seconds?: number;
    readonly totalDays?: number;
    readonly totalHours?: number;
    readonly totalMilliseconds?: number;
    readonly totalMicroseconds?: number;
    readonly totalNanoseconds?: number;
    readonly totalMinutes?: number;
    readonly totalSeconds?: number;

    constructor(data?: ITimeSpan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ticks = _data["ticks"];
            (this as any).days = _data["days"];
            (this as any).hours = _data["hours"];
            (this as any).milliseconds = _data["milliseconds"];
            (this as any).microseconds = _data["microseconds"];
            (this as any).nanoseconds = _data["nanoseconds"];
            (this as any).minutes = _data["minutes"];
            (this as any).seconds = _data["seconds"];
            (this as any).totalDays = _data["totalDays"];
            (this as any).totalHours = _data["totalHours"];
            (this as any).totalMilliseconds = _data["totalMilliseconds"];
            (this as any).totalMicroseconds = _data["totalMicroseconds"];
            (this as any).totalNanoseconds = _data["totalNanoseconds"];
            (this as any).totalMinutes = _data["totalMinutes"];
            (this as any).totalSeconds = _data["totalSeconds"];
        }
    }

    static fromJS(data: any): TimeSpan {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSpan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ticks"] = this.ticks;
        data["days"] = this.days;
        data["hours"] = this.hours;
        data["milliseconds"] = this.milliseconds;
        data["microseconds"] = this.microseconds;
        data["nanoseconds"] = this.nanoseconds;
        data["minutes"] = this.minutes;
        data["seconds"] = this.seconds;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["totalMilliseconds"] = this.totalMilliseconds;
        data["totalMicroseconds"] = this.totalMicroseconds;
        data["totalNanoseconds"] = this.totalNanoseconds;
        data["totalMinutes"] = this.totalMinutes;
        data["totalSeconds"] = this.totalSeconds;
        return data;
    }
}

export interface ITimeSpan {
    ticks?: number;
    days?: number;
    hours?: number;
    milliseconds?: number;
    microseconds?: number;
    nanoseconds?: number;
    minutes?: number;
    seconds?: number;
    totalDays?: number;
    totalHours?: number;
    totalMilliseconds?: number;
    totalMicroseconds?: number;
    totalNanoseconds?: number;
    totalMinutes?: number;
    totalSeconds?: number;
}

export class Type implements IType {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly isFunctionPointer?: boolean;
    readonly isUnmanagedFunctionPointer?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            (this as any).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (this as any).namespace = _data["namespace"];
            (this as any).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (this as any).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            (this as any).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : undefined as any;
            (this as any).isTypeDefinition = _data["isTypeDefinition"];
            (this as any).isArray = _data["isArray"];
            (this as any).isByRef = _data["isByRef"];
            (this as any).isPointer = _data["isPointer"];
            (this as any).isConstructedGenericType = _data["isConstructedGenericType"];
            (this as any).isGenericParameter = _data["isGenericParameter"];
            (this as any).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (this as any).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (this as any).isGenericType = _data["isGenericType"];
            (this as any).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (this as any).isSZArray = _data["isSZArray"];
            (this as any).isVariableBoundArray = _data["isVariableBoundArray"];
            (this as any).isByRefLike = _data["isByRefLike"];
            (this as any).isFunctionPointer = _data["isFunctionPointer"];
            (this as any).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (this as any).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (this as any).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (this as any).genericTypeArguments!.push(Type.fromJS(item));
            }
            (this as any).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (this as any).isAbstract = _data["isAbstract"];
            (this as any).isImport = _data["isImport"];
            (this as any).isSealed = _data["isSealed"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isClass = _data["isClass"];
            (this as any).isNestedAssembly = _data["isNestedAssembly"];
            (this as any).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (this as any).isNestedFamily = _data["isNestedFamily"];
            (this as any).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (this as any).isNestedPrivate = _data["isNestedPrivate"];
            (this as any).isNestedPublic = _data["isNestedPublic"];
            (this as any).isNotPublic = _data["isNotPublic"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isAutoLayout = _data["isAutoLayout"];
            (this as any).isExplicitLayout = _data["isExplicitLayout"];
            (this as any).isLayoutSequential = _data["isLayoutSequential"];
            (this as any).isAnsiClass = _data["isAnsiClass"];
            (this as any).isAutoClass = _data["isAutoClass"];
            (this as any).isUnicodeClass = _data["isUnicodeClass"];
            (this as any).isCOMObject = _data["isCOMObject"];
            (this as any).isContextful = _data["isContextful"];
            (this as any).isEnum = _data["isEnum"];
            (this as any).isMarshalByRef = _data["isMarshalByRef"];
            (this as any).isPrimitive = _data["isPrimitive"];
            (this as any).isValueType = _data["isValueType"];
            (this as any).isSignatureType = _data["isSignatureType"];
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : undefined as any;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : undefined as any;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : undefined as any;
            (this as any).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : undefined as any;
            (this as any).isSerializable = _data["isSerializable"];
            (this as any).containsGenericParameters = _data["containsGenericParameters"];
            (this as any).isVisible = _data["isVisible"];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : undefined as any;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item ? item.toJSON() : undefined as any);
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : undefined as any;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : undefined as any;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : undefined as any;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : undefined as any;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        return data;
    }
}

export interface IType {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    isFunctionPointer?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
}

export enum TypeAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _24 = 24,
    _32 = 32,
    _128 = 128,
    _256 = 256,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _65536 = 65536,
    _131072 = 131072,
    _196608 = 196608,
    _262144 = 262144,
    _264192 = 264192,
    _1048576 = 1048576,
    _12582912 = 12582912,
}

export class TypeInfo implements ITypeInfo {
    readonly name?: string | undefined;
    readonly customAttributes?: CustomAttributeData[] | undefined;
    readonly isCollectible?: boolean;
    readonly metadataToken?: number;
    readonly isInterface?: boolean;
    memberType?: MemberTypes;
    readonly namespace?: string | undefined;
    readonly assemblyQualifiedName?: string | undefined;
    readonly fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    readonly isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    readonly isTypeDefinition?: boolean;
    readonly isArray?: boolean;
    readonly isByRef?: boolean;
    readonly isPointer?: boolean;
    readonly isConstructedGenericType?: boolean;
    readonly isGenericParameter?: boolean;
    readonly isGenericTypeParameter?: boolean;
    readonly isGenericMethodParameter?: boolean;
    readonly isGenericType?: boolean;
    readonly isGenericTypeDefinition?: boolean;
    readonly isSZArray?: boolean;
    readonly isVariableBoundArray?: boolean;
    readonly isByRefLike?: boolean;
    readonly isFunctionPointer?: boolean;
    readonly isUnmanagedFunctionPointer?: boolean;
    readonly hasElementType?: boolean;
    readonly genericTypeArguments?: Type[] | undefined;
    readonly genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    readonly isAbstract?: boolean;
    readonly isImport?: boolean;
    readonly isSealed?: boolean;
    readonly isSpecialName?: boolean;
    readonly isClass?: boolean;
    readonly isNestedAssembly?: boolean;
    readonly isNestedFamANDAssem?: boolean;
    readonly isNestedFamily?: boolean;
    readonly isNestedFamORAssem?: boolean;
    readonly isNestedPrivate?: boolean;
    readonly isNestedPublic?: boolean;
    readonly isNotPublic?: boolean;
    readonly isPublic?: boolean;
    readonly isAutoLayout?: boolean;
    readonly isExplicitLayout?: boolean;
    readonly isLayoutSequential?: boolean;
    readonly isAnsiClass?: boolean;
    readonly isAutoClass?: boolean;
    readonly isUnicodeClass?: boolean;
    readonly isCOMObject?: boolean;
    readonly isContextful?: boolean;
    readonly isEnum?: boolean;
    readonly isMarshalByRef?: boolean;
    readonly isPrimitive?: boolean;
    readonly isValueType?: boolean;
    readonly isSignatureType?: boolean;
    readonly isSecurityCritical?: boolean;
    readonly isSecuritySafeCritical?: boolean;
    readonly isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    readonly guid?: string;
    baseType?: Type;
    readonly isSerializable?: boolean;
    readonly containsGenericParameters?: boolean;
    readonly isVisible?: boolean;
    readonly genericTypeParameters?: Type[] | undefined;
    readonly declaredConstructors?: ConstructorInfo[] | undefined;
    readonly declaredEvents?: EventInfo[] | undefined;
    readonly declaredFields?: FieldInfo[] | undefined;
    readonly declaredMembers?: MemberInfo[] | undefined;
    readonly declaredMethods?: MethodInfo[] | undefined;
    readonly declaredNestedTypes?: TypeInfo[] | undefined;
    readonly declaredProperties?: PropertyInfo[] | undefined;
    readonly implementedInterfaces?: Type[] | undefined;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).name = _data["name"];
            if (Array.isArray(_data["customAttributes"])) {
                (this as any).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (this as any).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (this as any).isCollectible = _data["isCollectible"];
            (this as any).metadataToken = _data["metadataToken"];
            (this as any).isInterface = _data["isInterface"];
            this.memberType = _data["memberType"];
            (this as any).namespace = _data["namespace"];
            (this as any).assemblyQualifiedName = _data["assemblyQualifiedName"];
            (this as any).fullName = _data["fullName"];
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined as any;
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            (this as any).isNested = _data["isNested"];
            this.declaringType = _data["declaringType"] ? Type.fromJS(_data["declaringType"]) : undefined as any;
            this.declaringMethod = _data["declaringMethod"] ? MethodBase.fromJS(_data["declaringMethod"]) : undefined as any;
            this.reflectedType = _data["reflectedType"] ? Type.fromJS(_data["reflectedType"]) : undefined as any;
            this.underlyingSystemType = _data["underlyingSystemType"] ? Type.fromJS(_data["underlyingSystemType"]) : undefined as any;
            (this as any).isTypeDefinition = _data["isTypeDefinition"];
            (this as any).isArray = _data["isArray"];
            (this as any).isByRef = _data["isByRef"];
            (this as any).isPointer = _data["isPointer"];
            (this as any).isConstructedGenericType = _data["isConstructedGenericType"];
            (this as any).isGenericParameter = _data["isGenericParameter"];
            (this as any).isGenericTypeParameter = _data["isGenericTypeParameter"];
            (this as any).isGenericMethodParameter = _data["isGenericMethodParameter"];
            (this as any).isGenericType = _data["isGenericType"];
            (this as any).isGenericTypeDefinition = _data["isGenericTypeDefinition"];
            (this as any).isSZArray = _data["isSZArray"];
            (this as any).isVariableBoundArray = _data["isVariableBoundArray"];
            (this as any).isByRefLike = _data["isByRefLike"];
            (this as any).isFunctionPointer = _data["isFunctionPointer"];
            (this as any).isUnmanagedFunctionPointer = _data["isUnmanagedFunctionPointer"];
            (this as any).hasElementType = _data["hasElementType"];
            if (Array.isArray(_data["genericTypeArguments"])) {
                (this as any).genericTypeArguments = [] as any;
                for (let item of _data["genericTypeArguments"])
                    (this as any).genericTypeArguments!.push(Type.fromJS(item));
            }
            (this as any).genericParameterPosition = _data["genericParameterPosition"];
            this.genericParameterAttributes = _data["genericParameterAttributes"];
            this.attributes = _data["attributes"];
            (this as any).isAbstract = _data["isAbstract"];
            (this as any).isImport = _data["isImport"];
            (this as any).isSealed = _data["isSealed"];
            (this as any).isSpecialName = _data["isSpecialName"];
            (this as any).isClass = _data["isClass"];
            (this as any).isNestedAssembly = _data["isNestedAssembly"];
            (this as any).isNestedFamANDAssem = _data["isNestedFamANDAssem"];
            (this as any).isNestedFamily = _data["isNestedFamily"];
            (this as any).isNestedFamORAssem = _data["isNestedFamORAssem"];
            (this as any).isNestedPrivate = _data["isNestedPrivate"];
            (this as any).isNestedPublic = _data["isNestedPublic"];
            (this as any).isNotPublic = _data["isNotPublic"];
            (this as any).isPublic = _data["isPublic"];
            (this as any).isAutoLayout = _data["isAutoLayout"];
            (this as any).isExplicitLayout = _data["isExplicitLayout"];
            (this as any).isLayoutSequential = _data["isLayoutSequential"];
            (this as any).isAnsiClass = _data["isAnsiClass"];
            (this as any).isAutoClass = _data["isAutoClass"];
            (this as any).isUnicodeClass = _data["isUnicodeClass"];
            (this as any).isCOMObject = _data["isCOMObject"];
            (this as any).isContextful = _data["isContextful"];
            (this as any).isEnum = _data["isEnum"];
            (this as any).isMarshalByRef = _data["isMarshalByRef"];
            (this as any).isPrimitive = _data["isPrimitive"];
            (this as any).isValueType = _data["isValueType"];
            (this as any).isSignatureType = _data["isSignatureType"];
            (this as any).isSecurityCritical = _data["isSecurityCritical"];
            (this as any).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (this as any).isSecurityTransparent = _data["isSecurityTransparent"];
            this.structLayoutAttribute = _data["structLayoutAttribute"] ? StructLayoutAttribute.fromJS(_data["structLayoutAttribute"]) : undefined as any;
            this.typeInitializer = _data["typeInitializer"] ? ConstructorInfo.fromJS(_data["typeInitializer"]) : undefined as any;
            this.typeHandle = _data["typeHandle"] ? RuntimeTypeHandle.fromJS(_data["typeHandle"]) : undefined as any;
            (this as any).guid = _data["guid"];
            this.baseType = _data["baseType"] ? Type.fromJS(_data["baseType"]) : undefined as any;
            (this as any).isSerializable = _data["isSerializable"];
            (this as any).containsGenericParameters = _data["containsGenericParameters"];
            (this as any).isVisible = _data["isVisible"];
            if (Array.isArray(_data["genericTypeParameters"])) {
                (this as any).genericTypeParameters = [] as any;
                for (let item of _data["genericTypeParameters"])
                    (this as any).genericTypeParameters!.push(Type.fromJS(item));
            }
            if (Array.isArray(_data["declaredConstructors"])) {
                (this as any).declaredConstructors = [] as any;
                for (let item of _data["declaredConstructors"])
                    (this as any).declaredConstructors!.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredEvents"])) {
                (this as any).declaredEvents = [] as any;
                for (let item of _data["declaredEvents"])
                    (this as any).declaredEvents!.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredFields"])) {
                (this as any).declaredFields = [] as any;
                for (let item of _data["declaredFields"])
                    (this as any).declaredFields!.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMembers"])) {
                (this as any).declaredMembers = [] as any;
                for (let item of _data["declaredMembers"])
                    (this as any).declaredMembers!.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredMethods"])) {
                (this as any).declaredMethods = [] as any;
                for (let item of _data["declaredMethods"])
                    (this as any).declaredMethods!.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredNestedTypes"])) {
                (this as any).declaredNestedTypes = [] as any;
                for (let item of _data["declaredNestedTypes"])
                    (this as any).declaredNestedTypes!.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data["declaredProperties"])) {
                (this as any).declaredProperties = [] as any;
                for (let item of _data["declaredProperties"])
                    (this as any).declaredProperties!.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data["implementedInterfaces"])) {
                (this as any).implementedInterfaces = [] as any;
                for (let item of _data["implementedInterfaces"])
                    (this as any).implementedInterfaces!.push(Type.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        data["isInterface"] = this.isInterface;
        data["memberType"] = this.memberType;
        data["namespace"] = this.namespace;
        data["assemblyQualifiedName"] = this.assemblyQualifiedName;
        data["fullName"] = this.fullName;
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined as any;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        data["isNested"] = this.isNested;
        data["declaringType"] = this.declaringType ? this.declaringType.toJSON() : undefined as any;
        data["declaringMethod"] = this.declaringMethod ? this.declaringMethod.toJSON() : undefined as any;
        data["reflectedType"] = this.reflectedType ? this.reflectedType.toJSON() : undefined as any;
        data["underlyingSystemType"] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : undefined as any;
        data["isTypeDefinition"] = this.isTypeDefinition;
        data["isArray"] = this.isArray;
        data["isByRef"] = this.isByRef;
        data["isPointer"] = this.isPointer;
        data["isConstructedGenericType"] = this.isConstructedGenericType;
        data["isGenericParameter"] = this.isGenericParameter;
        data["isGenericTypeParameter"] = this.isGenericTypeParameter;
        data["isGenericMethodParameter"] = this.isGenericMethodParameter;
        data["isGenericType"] = this.isGenericType;
        data["isGenericTypeDefinition"] = this.isGenericTypeDefinition;
        data["isSZArray"] = this.isSZArray;
        data["isVariableBoundArray"] = this.isVariableBoundArray;
        data["isByRefLike"] = this.isByRefLike;
        data["isFunctionPointer"] = this.isFunctionPointer;
        data["isUnmanagedFunctionPointer"] = this.isUnmanagedFunctionPointer;
        data["hasElementType"] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data["genericTypeArguments"] = [];
            for (let item of this.genericTypeArguments)
                data["genericTypeArguments"].push(item ? item.toJSON() : undefined as any);
        }
        data["genericParameterPosition"] = this.genericParameterPosition;
        data["genericParameterAttributes"] = this.genericParameterAttributes;
        data["attributes"] = this.attributes;
        data["isAbstract"] = this.isAbstract;
        data["isImport"] = this.isImport;
        data["isSealed"] = this.isSealed;
        data["isSpecialName"] = this.isSpecialName;
        data["isClass"] = this.isClass;
        data["isNestedAssembly"] = this.isNestedAssembly;
        data["isNestedFamANDAssem"] = this.isNestedFamANDAssem;
        data["isNestedFamily"] = this.isNestedFamily;
        data["isNestedFamORAssem"] = this.isNestedFamORAssem;
        data["isNestedPrivate"] = this.isNestedPrivate;
        data["isNestedPublic"] = this.isNestedPublic;
        data["isNotPublic"] = this.isNotPublic;
        data["isPublic"] = this.isPublic;
        data["isAutoLayout"] = this.isAutoLayout;
        data["isExplicitLayout"] = this.isExplicitLayout;
        data["isLayoutSequential"] = this.isLayoutSequential;
        data["isAnsiClass"] = this.isAnsiClass;
        data["isAutoClass"] = this.isAutoClass;
        data["isUnicodeClass"] = this.isUnicodeClass;
        data["isCOMObject"] = this.isCOMObject;
        data["isContextful"] = this.isContextful;
        data["isEnum"] = this.isEnum;
        data["isMarshalByRef"] = this.isMarshalByRef;
        data["isPrimitive"] = this.isPrimitive;
        data["isValueType"] = this.isValueType;
        data["isSignatureType"] = this.isSignatureType;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["structLayoutAttribute"] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : undefined as any;
        data["typeInitializer"] = this.typeInitializer ? this.typeInitializer.toJSON() : undefined as any;
        data["typeHandle"] = this.typeHandle ? this.typeHandle.toJSON() : undefined as any;
        data["guid"] = this.guid;
        data["baseType"] = this.baseType ? this.baseType.toJSON() : undefined as any;
        data["isSerializable"] = this.isSerializable;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data["genericTypeParameters"] = [];
            for (let item of this.genericTypeParameters)
                data["genericTypeParameters"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.declaredConstructors)) {
            data["declaredConstructors"] = [];
            for (let item of this.declaredConstructors)
                data["declaredConstructors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.declaredEvents)) {
            data["declaredEvents"] = [];
            for (let item of this.declaredEvents)
                data["declaredEvents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.declaredFields)) {
            data["declaredFields"] = [];
            for (let item of this.declaredFields)
                data["declaredFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.declaredMembers)) {
            data["declaredMembers"] = [];
            for (let item of this.declaredMembers)
                data["declaredMembers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.declaredMethods)) {
            data["declaredMethods"] = [];
            for (let item of this.declaredMethods)
                data["declaredMethods"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data["declaredNestedTypes"] = [];
            for (let item of this.declaredNestedTypes)
                data["declaredNestedTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.declaredProperties)) {
            data["declaredProperties"] = [];
            for (let item of this.declaredProperties)
                data["declaredProperties"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data["implementedInterfaces"] = [];
            for (let item of this.implementedInterfaces)
                data["implementedInterfaces"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITypeInfo {
    name?: string | undefined;
    customAttributes?: CustomAttributeData[] | undefined;
    isCollectible?: boolean;
    metadataToken?: number;
    isInterface?: boolean;
    memberType?: MemberTypes;
    namespace?: string | undefined;
    assemblyQualifiedName?: string | undefined;
    fullName?: string | undefined;
    assembly?: Assembly;
    module?: Module;
    isNested?: boolean;
    declaringType?: Type;
    declaringMethod?: MethodBase;
    reflectedType?: Type;
    underlyingSystemType?: Type;
    isTypeDefinition?: boolean;
    isArray?: boolean;
    isByRef?: boolean;
    isPointer?: boolean;
    isConstructedGenericType?: boolean;
    isGenericParameter?: boolean;
    isGenericTypeParameter?: boolean;
    isGenericMethodParameter?: boolean;
    isGenericType?: boolean;
    isGenericTypeDefinition?: boolean;
    isSZArray?: boolean;
    isVariableBoundArray?: boolean;
    isByRefLike?: boolean;
    isFunctionPointer?: boolean;
    isUnmanagedFunctionPointer?: boolean;
    hasElementType?: boolean;
    genericTypeArguments?: Type[] | undefined;
    genericParameterPosition?: number;
    genericParameterAttributes?: GenericParameterAttributes;
    attributes?: TypeAttributes;
    isAbstract?: boolean;
    isImport?: boolean;
    isSealed?: boolean;
    isSpecialName?: boolean;
    isClass?: boolean;
    isNestedAssembly?: boolean;
    isNestedFamANDAssem?: boolean;
    isNestedFamily?: boolean;
    isNestedFamORAssem?: boolean;
    isNestedPrivate?: boolean;
    isNestedPublic?: boolean;
    isNotPublic?: boolean;
    isPublic?: boolean;
    isAutoLayout?: boolean;
    isExplicitLayout?: boolean;
    isLayoutSequential?: boolean;
    isAnsiClass?: boolean;
    isAutoClass?: boolean;
    isUnicodeClass?: boolean;
    isCOMObject?: boolean;
    isContextful?: boolean;
    isEnum?: boolean;
    isMarshalByRef?: boolean;
    isPrimitive?: boolean;
    isValueType?: boolean;
    isSignatureType?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
    structLayoutAttribute?: StructLayoutAttribute;
    typeInitializer?: ConstructorInfo;
    typeHandle?: RuntimeTypeHandle;
    guid?: string;
    baseType?: Type;
    isSerializable?: boolean;
    containsGenericParameters?: boolean;
    isVisible?: boolean;
    genericTypeParameters?: Type[] | undefined;
    declaredConstructors?: ConstructorInfo[] | undefined;
    declaredEvents?: EventInfo[] | undefined;
    declaredFields?: FieldInfo[] | undefined;
    declaredMembers?: MemberInfo[] | undefined;
    declaredMethods?: MethodInfo[] | undefined;
    declaredNestedTypes?: TypeInfo[] | undefined;
    declaredProperties?: PropertyInfo[] | undefined;
    implementedInterfaces?: Type[] | undefined;
}

export class WithinRadiusAttendantResponse implements IWithinRadiusAttendantResponse {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    photoUrl?: string | undefined;
    yearsExperience?: number;
    distance?: number;
    snippet?: string | undefined;
    zipCode?: number;
    state?: string | undefined;
    hourAvailability?: number;
    scheduleRaw?: string | undefined;
    schedule?: Schedule[] | undefined;

    constructor(data?: IWithinRadiusAttendantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.photoUrl = _data["photoUrl"];
            this.yearsExperience = _data["yearsExperience"];
            this.distance = _data["distance"];
            this.snippet = _data["snippet"];
            this.zipCode = _data["zipCode"];
            this.state = _data["state"];
            this.hourAvailability = _data["hourAvailability"];
            this.scheduleRaw = _data["scheduleRaw"];
            if (Array.isArray(_data["schedule"])) {
                this.schedule = [] as any;
                for (let item of _data["schedule"])
                    this.schedule!.push(Schedule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WithinRadiusAttendantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WithinRadiusAttendantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["photoUrl"] = this.photoUrl;
        data["yearsExperience"] = this.yearsExperience;
        data["distance"] = this.distance;
        data["snippet"] = this.snippet;
        data["zipCode"] = this.zipCode;
        data["state"] = this.state;
        data["hourAvailability"] = this.hourAvailability;
        data["scheduleRaw"] = this.scheduleRaw;
        if (Array.isArray(this.schedule)) {
            data["schedule"] = [];
            for (let item of this.schedule)
                data["schedule"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWithinRadiusAttendantResponse {
    userId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    photoUrl?: string | undefined;
    yearsExperience?: number;
    distance?: number;
    snippet?: string | undefined;
    zipCode?: number;
    state?: string | undefined;
    hourAvailability?: number;
    scheduleRaw?: string | undefined;
    schedule?: Schedule[] | undefined;
}

export class WithinRadiusAttendantResponseIEnumerableResponseModel implements IWithinRadiusAttendantResponseIEnumerableResponseModel {
    data?: WithinRadiusAttendantResponse[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IWithinRadiusAttendantResponseIEnumerableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WithinRadiusAttendantResponse.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WithinRadiusAttendantResponseIEnumerableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WithinRadiusAttendantResponseIEnumerableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IWithinRadiusAttendantResponseIEnumerableResponseModel {
    data?: WithinRadiusAttendantResponse[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export class WorkPreference implements IWorkPreference {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;

    constructor(data?: IWorkPreference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : undefined as any;
            this.updatedOn = _data["updatedOn"] ? new Date(_data["updatedOn"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WorkPreference {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPreference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : undefined as any;
        data["updatedOn"] = this.updatedOn ? this.updatedOn.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWorkPreference {
    createdOn?: Date;
    updatedOn?: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted?: boolean;
    id?: number;
    name?: string | undefined;
}

export class WorkPreferenceIEnumerableResponseModel implements IWorkPreferenceIEnumerableResponseModel {
    data?: WorkPreference[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;

    constructor(data?: IWorkPreferenceIEnumerableResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WorkPreference.fromJS(item));
            }
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WorkPreferenceIEnumerableResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new WorkPreferenceIEnumerableResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface IWorkPreferenceIEnumerableResponseModel {
    data?: WorkPreference[] | undefined;
    isSuccess?: boolean;
    message?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}